import React = require('react')

import { List } from './List'
import { EQuoteType, TRANSFER_DETAILS } from './models'

interface Properties {
    userName:  string
    quoteType: EQuoteType
}

interface Callbacks {
}

interface Props extends Properties, Callbacks {}

interface State {
}

export class Confirmation extends React.Component<Props, State> {

    render() {
        switch(this.props.quoteType) {
            case EQuoteType.Replacement: {
                return (
                    <div className="cc-confirmation cc-confirmation_replacement text-center">
                        <div className="cc-confirmation__title">
                            <img className="cc-confirmation__tick" src="images/tick-circle.png" alt="Tick Success"/>
                            Your order has been completed and we have emailed you the invoice
                        </div>
                        <div className="cc-confirmation__title">
                            Whats next
                        </div>

                        <div className="cc-confirmation__paragraph">
                            As soon as your payment reflects into our account, we will have your phone dispatched for delivery. In the meantime, we're packaging it nice 'n tight ready to be delivered.
                        </div>
                        <div className="cc-confirmation__paragraph">
                            We’ll send your tracking details as soon as it ships
                        </div>

                        <div className="cc-confirmation__title">
                            Account details
                        </div>

                        <List
                            className="cc-confirmation__list"
                            items={[
                                TRANSFER_DETAILS.BANK,
                                `ACCOUNT NUMBER: ${TRANSFER_DETAILS.ACCOUNT_NUMBER}`,
                                TRANSFER_DETAILS.COMPANY
                            ]}
                        />
                    </div>
                )
            }
            case EQuoteType.CollectAndRepair: {
                return (
                    <div className="cc-confirmation text-center">
                        <div className="cc-confirmation__title">
                            Thanks, {this.props.userName}! We`re on it.
                        </div>
                        <div className="cc-confirmation__title">
                            We`ll be in touch to make your collection arrangements for you
                        </div>

                        <div className="cc-confirmation__heading">
                            What we`ll do
                        </div>

                        <List
                            className="cc-confirmation__list"
                            listStyle="check"
                            items={[
                                'Arrange a suitable collection time for you',
                                'Get your phone fixed by one of our experienced experts',
                                'Do a 45-point quality test to make sure it’s good as new',
                                'Deliver it back to you as fast as humanly possible ! '
                            ]}
                        />

                        <div className="cc-confirmation__heading">
                            What you need to do
                        </div>

                        <List
                            className="cc-confirmation__list"
                            items={[
                                'Package your phone in a small box or bubble wrap',
                                'Take out your sim card (and memory card if it has one)',
                                'Switch your phone off'
                            ]}
                        />
                    </div>
                )
            }
            case EQuoteType.InStoreRepair: {
                return (
                    <div className="cc-confirmation text-center">
                        <div className="cc-confirmation__title">
                            Thanks, {this.props.userName}! We're on it.
                        </div>
                        <div className="cc-confirmation__title">
                            We'll be in touch to make arrangements for you.
                        </div>
                        <div className="cc-confirmation__heading">
                            Whats Next
                        </div>

                        <List
                            className="cc-confirmation__list"
                            listStyle="check"
                            items={[
                                'We`ll arrange a suitable time for you to bring your phone in',
                                'Get your phone fixed by one of our experienced experts',
                                'Do a 45-point quality test to make sure it’s good as new',
                                'Get it back to you as fast as humanly possible!'
                            ]}
                        />
                        <div className="cc-confirmation__note">
                            *You will be able to pay in store with cash, credit card or debit card.
                        </div>
                    </div>
                )
            }
            default: {
                return null
            }
        }
    }
}
